'use client';

import Icon from '@/components/ui/AppIcon';

export default function HowItWorks() {
  const steps = [
    {
      number: '1',
      icon: 'DocumentTextIcon',
      title: 'Fill Details',
      description: 'Enter your passenger and flight information'
    },
    {
      number: '2',
      icon: 'CreditCardIcon',
      title: 'Make Payment',
      description: 'Secure payment in GBP with instant confirmation'
    },
    {
      number: '3',
      icon: 'EnvelopeIcon',
      title: 'Receive Ticket',
      description: 'Get your verifiable flight ticket via email within minutes'
    },
    {
      number: '4',
      icon: 'CheckBadgeIcon',
      title: 'Use for Visa',
      description: 'Submit to embassy or airline with valid PNR'
    }
  ];

  return (
    <div className="bg-gradient-to-br from-blue-600 to-purple-600 rounded-2xl shadow-xl p-8 text-white">
      <div className="text-center mb-8">
        <h2 className="text-3xl font-black mb-2">How It Works</h2>
        <p className="text-blue-100">Simple 4-step process to get your onward ticket</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {steps?.map((step, index) => (
          <div key={index} className="relative">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center h-full">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-white/20 rounded-full mb-4">
                <Icon name={step?.icon} size={32} className="text-white" />
              </div>
              <div className="absolute -top-3 -right-3 w-10 h-10 bg-yellow-400 rounded-full flex items-center justify-center font-black text-blue-900 text-lg">
                {step?.number}
              </div>
              <h3 className="font-bold text-lg mb-2">{step?.title}</h3>
              <p className="text-sm text-blue-100">{step?.description}</p>
            </div>
            {index < steps?.length - 1 && (
              <div className="hidden lg:block absolute top-1/2 -right-3 transform -translate-y-1/2">
                <Icon name="ChevronRightIcon" size={24} className="text-white/50" />
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}